<template>
  <picker-field
    :label="label"
    :value="value"
    :is-focus="isFocus"
    title="选择人员"
    ref="picker"
    @open="onSearch"
  >
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="em_name"
        placeholder="输入姓名查找"
        ref="searchBar"
        :auto-search="true"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.em_name }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.em_mobile }}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList,
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "选择人员",
    },
    value: String,
    listUrl: {
      type: String,
      default: "/api/document/employee/base_list",
    },
    extraParams: Object
  },
  data() {
    return {
      isFocus: false,
      allowEmptySearch: false,
      defaultCondition: [{
        field: "em_class",
        operation: "=",
        value: "正式"
      }]
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.em_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  },
};
</script>